// src/areaAssociados/HomeAssociados.js
import React, { useState, useEffect, useRef, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { FaShoppingCart, FaQrcode, FaMoneyBillAlt, FaListAlt, FaComments, FaBell, FaChartLine, FaTachometerAlt, FaCalendarAlt, FaDollarSign, FaArchway, FaBook, FaImage } from 'react-icons/fa';
import ButtonSquad from '../components/ButtonSquad';
import api from '../services/api';
import AppContext from '../api/AppContext';
import io from 'socket.io-client';
import CarrosselAvisos from './CarrosselAvisos';
import ModalAviso from './ModalAviso';

const InterfaceAssociados = () => {
  const navigate = useNavigate();
  const [colunas, setColunas] = useState(getGridColumns());
  const [isMobile, setIsMobile] = useState(window.innerWidth < 900);
  const [notificacoes, setNotificacoes] = useState([]);
  const [socket, setSocket] = useState(null);
  const [saldo, setSaldo] = useState(0);
  const { token, user: ctxUser } = useContext(AppContext);
  let lsUser = null;
  try { lsUser = JSON.parse(localStorage.getItem('user')); } catch (_) {}
  const user = ctxUser || lsUser;
  const [showNotifications, setShowNotifications] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const notificationRef = useRef(null);
  const [avisoSelecionado, setAvisoSelecionado] = useState(null);

  // Botões base (com texto dinâmico para saldo)
  const botoes = [
    //{
   //   id: 'carteirinha',
   //   texto: 'Carteirinha QR Code',
   //   rota: '/member/carteirinha',
   //   icon: FaQrcode,
   //   gradient: 'linear-gradient(135deg, #2675d5ff 0%, #70aeffff 100%)',
   //   categoria: 'associado',
   //   desabilitado: true
   // },
    {
      id: 'saldo',
      texto: `Recarga de Saldo `,
      rota: null,
      icon: FaMoneyBillAlt,
      gradient: 'linear-gradient(135deg, #cccccc 0%, #999999 100%)',
      categoria: 'lanchonete',
      desabilitado: true
    },
    {
      id: 'pedido',
      texto: 'Cardápio',
      rota: '/enviarpedido',
      icon: FaShoppingCart,
      gradient: 'linear-gradient(135deg, #ff5650ff 0%, #FFA07A 100%)',
      categoria: 'lanchonete'
    },
    {
      id: 'atendimento',
      texto: 'CHAT',
      rota: '/member/chat',
      icon: FaComments,
      gradient: 'linear-gradient(135deg, #6A5ACD 0%, #9370DB 100%)',
      categoria: 'comunicacao'
    },
    {
      id: 'eventos',
      texto: 'Agenda de Eventos',
      rota: '/member/eventos',
      icon: FaCalendarAlt,
      gradient: 'linear-gradient(135deg, #0891B2 0%, #22D3EE 100%)',
      categoria: 'comunicacao'
    },
    {
      id: 'espacos',
      texto: 'Espaços',
      rota: '/member/espacos',
      icon: FaArchway,
      gradient: 'linear-gradient(135deg, #e65100 0%, #fb8c00 100%)',
      categoria: 'comunicacao'
    },
    {
      id: 'base-conhecimento',
      texto: 'Informações Úteis',
      rota: '/member/base-conhecimento',
      icon: FaBook,
      gradient: 'linear-gradient(135deg, #1565c0 0%, #42a5f5 100%)',
      categoria: 'comunicacao'
    }
  ];

  // Botões de Administração
  const botoesAdministracao = [
    {
      id: 'prestacao-financeira',
      texto: 'Financeiro',
      rota: '/member/financeiro',
      icon: FaDollarSign,
      gradient: 'linear-gradient(135deg, #00897B 0%, #26A69A 100%)',
      categoria: 'comunicacao'
    },
    {
      id: 'relatorio-gestao',
      texto: 'Relatório de Gestão e Avanço',
      rota: '/member/relatoriogestao',
      icon: FaChartLine,
      gradient: 'linear-gradient(135deg, #18347b 0%, #5099dd 100%)',
      categoria: 'administracao'
    },
    {
      id: 'galeria-reformas',
      texto: 'Galeria de Reformas',
      rota: '/member/galeria-reformas',
      icon: FaImage,
      gradient: 'linear-gradient(135deg, #c62828 0%, #e53935 100%)',
      categoria: 'administracao'
    }
  ];

  const botoesComunicacao = botoes.filter(b => b.categoria === 'comunicacao');
  const botaoAssociado = botoes.find(b => b.categoria === 'associado');
  const botoesLanchonete = botoes.filter(b => b.categoria === 'lanchonete');
  const [cardapioAtivo, setCardapioAtivo] = useState(false);

  useEffect(() => {
    api.get('/lanchonete').then(r => {
      if (r.data.success) setCardapioAtivo(r.data.data.cardapioAtivo !== false);
    }).catch(() => {});
  }, []);

  useEffect(() => {
    carregarNotificacoes();
    carregarSaldo();

    if (token) {
      const newSocket = io('https://app.olympicbarbacena.com.br', {
        auth: { token },
        transports: ['websocket', 'polling']
      });

      //newSocket.on('connect', () => console.log('✅ Conectado'));
      //newSocket.on('disconnect', () => //console.log('❌ Desconectado'));
      newSocket.on('connect_error', (error) => console.error('❌ Erro:', error));
      newSocket.on('updateOnlineConnections', adicionarNotificacao);
      newSocket.on('notification', adicionarNotificacao);
      newSocket.on('saldo:update', (data) => setSaldo(data.saldo));
      newSocket.on('balance:update', (data) => setSaldo(data.balance));

      newSocket.on('chat:message', (data) => {
        // Só conta mensagens de membro (resposta da secretaria/transmissão não gera badge)
        if (data.message?.sender?.role && data.message.sender.role !== 'member') return;
        //console.log('💬 Nova mensagem de chat recebida:', data);
        if (data.message.sender.userId !== user?._id) {
          const notificacao = {
            id: `chat-${data.message._id}`,
            mensagem: `Nova mensagem de ${data.message.sender.name}: ${data.message.content.substring(0, 50)}${data.message.content.length > 50 ? '...' : ''}`,
            tipo: 'chat',
            timestamp: data.message.createdAt,
            lida: false,
            conversationId: data.conversationId
          };
          adicionarNotificacao(notificacao);
          setUnreadCount(prev => prev + 1);
        }
      });

      newSocket.on('chat:notification', (data) => {
        if (data.message?.sender?.role && data.message.sender.role !== 'member') return;
        //console.log('🔔 Notificação de chat recebida:', data);
        const notificacao = {
          id: `chat-${data.message._id}`,
          mensagem: `Nova mensagem de ${data.message.sender.name}: ${data.message.content.substring(0, 50)}${data.message.content.length > 50 ? '...' : ''}`,
          tipo: 'chat',
          timestamp: data.message.createdAt,
          lida: false,
          conversationId: data.conversationId
        };
        adicionarNotificacao(notificacao);
        setUnreadCount(prev => prev + 1);
      });

      newSocket.on('chat:message', () => {
        setUnreadCount(prev => prev + 1);
      });

      setSocket(newSocket);
      return () => newSocket.close();
    }

    const handleResize = () => {
      setColunas(getGridColumns());
      setIsMobile(window.innerWidth < 900);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const fetchUnreadCount = async () => {
      try {
        const res = await api.get('/chat/unread-count');
        const data = res.data;
        if (data?.data?.unreadCount !== undefined) {
          setUnreadCount(data.data.unreadCount);
        }
      } catch (err) {
        console.error('Erro ao buscar mensagens não lidas:', err);
      }
    };
    fetchUnreadCount();
    const interval = setInterval(fetchUnreadCount, 15000);
    
    const handleStorageChange = (e) => {
      if (e.key === 'chat-unread-update') {
        fetchUnreadCount();
      }
    };
    const handleUnreadUpdateEvent = () => {
      fetchUnreadCount();
    };
    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('chat-unread-update', handleUnreadUpdateEvent);
    
    return () => {
      clearInterval(interval);
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('chat-unread-update', handleUnreadUpdateEvent);
    };
  }, []);

  const adicionarNotificacao = (novaNotificacao) => {
    setNotificacoes(prev => [{
      id: novaNotificacao.id || Date.now() + Math.random(),
      mensagem: novaNotificacao.mensagem,
      tipo: novaNotificacao.tipo || 'info',
      timestamp: novaNotificacao.timestamp || new Date(),
      lida: false,
      conversationId: novaNotificacao.conversationId
    }, ...prev]);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const carregarNotificacoes = async () => {
    try {
      const response = await api.get('/notificacoes/my-notifications');
      if (response.data.success) {
        const notifs = response.data.notificacoes.map(notif => ({
          id: notif._id,
          mensagem: notif.mensagem,
          tipo: notif.tipo,
          timestamp: notif.createdAt,
          lida: notif.lida
        }));
        setNotificacoes(notifs);
      }
    } catch (error) {
      console.error('Erro ao carregar notificações:', error);
      setNotificacoes([
        { id: 1, mensagem: 'Bem-vindo ao Olympic Club!', lida: false, tipo: 'info', timestamp: new Date() }
      ]);
    }
  };

  const carregarSaldo = async () => {
    try {
      if (user && user._id) {
        const response = await api.get(`/minha-conta/saldo?userId=${user._id}`);

        if (response.status === 200) {
          const data = response.data;
          const saldo = data.saldo || data.balance || data.valor || 0;
          setSaldo(saldo);
        } else {
          setSaldo(0);
        }
      }
    } catch (error) {
      console.error('❌ Erro ao carregar saldo:', error);
      setSaldo(0);
    }
  };

  const handleFecharNotificacao = async (id, e) => {
    e.stopPropagation();
    try {
      await api.patch(`/notificacoes/${id}/ler`);
    } catch (error) {
      console.error('Erro ao marcar notificação como lida:', error);
    }
    setNotificacoes(prev => prev.filter(notif => notif.id !== id));
  };

  const marcarComoLida = async (id) => {
    try {
      await api.patch(`/notificacoes/${id}/ler`);
      setNotificacoes(prev => prev.map(notif =>
        notif.id === id ? { ...notif, lida: true } : notif
      ));
    } catch (error) {
      console.error('Erro ao marcar notificação como lida:', error);
      setNotificacoes(prev => prev.map(notif =>
        notif.id === id ? { ...notif, lida: true } : notif
      ));
    }
  };

  const handleNotificationClick = (notif) => {
    if (notif.tipo === 'chat' && notif.conversationId) {
      navigate(`/member/chat/${notif.conversationId}`);
      setNotificacoes(prev => prev.filter(n => n.id !== notif.id));
    } else {
      marcarComoLida(notif.id);
    }
  };

  const notificacoesNaoLidas = notificacoes.filter(notif => !notif.lida).length;

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: `repeat(${colunas}, 1fr)`,
    gap: isMobile ? '12px' : '24px',
    width: '100%',
  };

return (
    <Layout
      title={
        <div style={styles.titleContainer}>
          {isMobile && (
            <div style={styles.logoMobile}>
              <img
                src="/logo.png"
                alt="Logo Olympic Club"
                style={styles.logoImage}
                onError={(e) => e.target.style.display = 'none'}
              />
            </div>
          )}
          <div style={styles.welcomeText}>
            <div style={styles.welcomeTitle}>Bem-vindo(a)</div>
            <div style={styles.userName}>{user?.name || 'Associado'}</div>
          </div>
          {/* <div ref={notificationRef} style={{ position: 'relative' }}>
            <button style={styles.notificationBell} onClick={() => setShowNotifications(!showNotifications)}>
              <FaBell size={24} color="#1A3B7D" />
              {notificacoesNaoLidas > 0 && <span style={styles.notificationBadge}>{notificacoesNaoLidas}</span>}
            </button>
            {showNotifications && (
              <div style={styles.notificationDropdown}>
                <div style={styles.dropdownHeader}>
                  <span>Notificações</span>
                  <button
                    style={styles.closeDropdownButton}
                    onClick={() => setShowNotifications(false)}
                    title="Fechar"
                  >
                    ×
                  </button>
                </div>
                <div style={styles.dropdownList}>
                  {notificacoes.length > 0 ? (
                    notificacoes.map((notif) => (
                      <div
                        key={notif.id}
                        style={{
                          ...styles.dropdownItem,
                          ...(notif.lida ? styles.dropdownItemLida : styles.dropdownItemNaoLida)
                        }}
                        onClick={() => handleNotificationClick(notif)}
                      >
                        <div style={styles.dropdownContent}>
                          <span style={styles.dropdownText}>{notif.mensagem}</span>
                          <span style={styles.dropdownTime}>{formatTime(notif.timestamp)}</span>
                        </div>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleFecharNotificacao(notif.id, e);
                          }}
                          style={styles.dropdownClose}
                        >
                          ×
                        </button>
                      </div>
                    ))
                  ) : (
                    <div style={styles.dropdownEmpty}>
                      <FaBell size={20} color="#A0AEC0" />
                      <span>Nenhuma notificação</span>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div> */}
        </div>
      }
      showBackButton={false}
    >
      <div style={styles.container}>
        <CarrosselAvisos onNoticeClick={(aviso) => setAvisoSelecionado(aviso)} />
        <div style={styles.sectionsWrapper}>
          {/* Card com dois botões: Comunicação e Associado */}
          <div style={styles.categoryCard}>
            <div style={styles.categoryHeader}>
              <img
                src="/azulaotelefonista.png"
                alt="Ícone de comunicação"
                style={{
                  width: isMobile ? 50 : 50,
                  height: isMobile ? 50 : 50,
                  objectFit: 'contain',
                  marginRight: 1,
                }}
              />
              <h3 style={styles.categoryTitle}>Comunicação & Associado</h3>
            </div>
            <div style={gridStyle}>
              {botoesComunicacao.map((botao) => (
                <ButtonSquad
                  key={botao.id}
                  texto={botao.texto}
                  icon={botao.icon}
                  onClick={() => navigate(botao.rota)}
                  isMobile={isMobile}
                  gradient={botao.gradient}
                  badge={botao.id === 'atendimento' ? unreadCount : 0}
                  desabilitado={botao.desabilitado}
                />
              ))}
              {botaoAssociado && (
                <ButtonSquad
                  texto={botaoAssociado.texto}
                  icon={botaoAssociado.icon}
                  onClick={() => navigate(botaoAssociado.rota)}
                  isMobile={isMobile}
                  gradient={botaoAssociado.gradient}
                  desabilitado={botaoAssociado.desabilitado}
                />
              )}
            </div>
          </div>

          {/* Card com botões: Lanchonete */}
          <div style={styles.categoryCard}>
            <div style={styles.categoryHeader}>
              <img
                src="/azulaolanchess.png"
                alt="Ícone de lanchonete"
                style={{
                  width: isMobile ? 70 : 70,
                  height: isMobile ? 70 : 70,
                  objectFit: 'contain',
                  marginRight: 1,
                }}
              />
              <h3 style={styles.categoryTitle}>Lanchonete</h3>
            </div>
            <div style={gridStyle}>
              {botoesLanchonete.map((botao) => (
                <ButtonSquad
                  key={botao.id}
                  texto={botao.texto}
                  icon={botao.icon}
                  onClick={() => botao.rota && navigate(botao.rota)}
                  isMobile={isMobile}
                  gradient={botao.gradient}
                  desabilitado={botao.id === 'pedido' ? !cardapioAtivo : botao.desabilitado}
                />
              ))}
            </div>
          </div>

          {/* NOVO Card com botões: Administração */}
          <div style={styles.categoryCard}>
            <div style={styles.categoryHeader}>
              <img
                src="/admin-icon.png"
                alt="Ícone de administração"
                style={{
                  width: isMobile ? 50 : 50,
                  height: isMobile ? 50 : 50,
                  objectFit: 'contain',
                  marginRight: 1,
                }}
                onError={(e) => e.target.style.display = 'none'}
              />
              <h3 style={styles.categoryTitle}>Administração</h3>
            </div>
            <div style={gridStyle}>
              {botoesAdministracao.map((botao) => (
                <ButtonSquad
                  key={botao.id}
                  texto={botao.texto}
                  icon={botao.icon}
                  onClick={() => navigate(botao.rota)}
                  isMobile={isMobile}
                  gradient={botao.gradient}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Informações do Usuário */}
        <div style={styles.userInfoWrapper}>
          <div style={styles.userCard}>
            <div style={styles.userInfoItem}>
              <strong>Associado:</strong> {user?.dadosAssociado.TITULO || 'N/A'}
            </div>
            <div style={styles.userInfoItem}>
              <strong>Saldo atual da Lanchonete: </strong> R$ {saldo.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </div>
          </div>
        </div>
      </div>

      {avisoSelecionado && (
        <ModalAviso aviso={avisoSelecionado} onClose={() => setAvisoSelecionado(null)} />
      )}
    </Layout>
  );
};

// Funções auxiliares
const getGridColumns = () => {
  const largura = window.innerWidth;
  if (largura < 600) return 2;
  if (largura < 900) return 2;
  return 3;
};

const formatTime = (timestamp) => {
  const date = new Date(timestamp);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);

  if (diffMins < 1) return 'Agora';
  if (diffMins < 60) return `${diffMins}m`;
  if (diffHours < 24) return `${diffHours}h`;
  return date.toLocaleDateString('pt-BR');
};

// Estilos
const styles = {
  container: { width: '100%', minHeight: '100vh' },
  sectionsWrapper: { maxWidth: '1000px', margin: '0 auto', padding: '0 16px', display: 'flex', flexDirection: 'column', gap: '24px' },
  categoryCard: { backgroundColor: '#ffffff', borderRadius: '20px', padding: '20px 16px', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.03)', border: '1px solid #edf2f7' },
  categoryHeader: { display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px', paddingBottom: '8px', borderBottom: '1px solid #edf2f7' },
  categoryTitle: { fontFamily: 'Montserrat, sans-serif', fontSize: '16px', fontWeight: '600', color: '#1e293b', margin: 0 },
  userInfoWrapper: { display: 'flex', justifyContent: 'center', padding: '0 16px', marginTop: '24px' },
  userCard: { backgroundColor: '#ffffff', borderRadius: '16px', padding: '20px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.02)', border: '1px solid #edf2f7', maxWidth: '500px', width: '100%' },
  userInfoItem: { fontFamily: 'Montserrat, sans-serif', fontSize: '14px', color: '#334155', marginBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 0', borderBottom: '1px dashed #e2e8f0' },
  titleContainer: { display: 'flex', alignItems: 'center', gap: '12px', width: '100%', justifyContent: 'space-between' },
  logoMobile: { width: '48px', height: '48px', flexShrink: 0 },
  logoImage: { width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover', border: '2px solid #1A3B7D' },
  welcomeText: { display: 'flex', flexDirection: 'column', flex: 1 },
  welcomeTitle: { fontSize: '12px', color: '#64748b', fontWeight: '500', fontFamily: 'Montserrat, sans-serif' },
  userName: { fontSize: '16px', color: '#0f172a', fontWeight: '700', fontFamily: 'Montserrat, sans-serif' },
  notificationBell: { background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '50%', cursor: 'pointer', position: 'relative', padding: '8px', boxShadow: '0 2px 6px rgba(0, 0, 0, 0.02)', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '42px', height: '42px' },
  notificationBadge: { position: 'absolute', top: '-4px', right: '-4px', backgroundColor: '#ef4444', color: 'white', borderRadius: '50%', width: '18px', height: '18px', fontSize: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', border: '2px solid white' },
  notificationDropdown: { position: 'absolute', top: 'calc(100% + 10px)', right: '0', width: '300px', maxWidth: '90vw', backgroundColor: '#fff', borderRadius: '16px', boxShadow: '0 12px 28px rgba(0,0,0,0.15)', border: '1px solid #e2e8f0', zIndex: 1000, display: 'flex', flexDirection: 'column', maxHeight: '400px' },
  dropdownHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 16px', borderBottom: '1px solid #e2e8f0', fontWeight: '600', color: '#0f172a', fontFamily: 'Montserrat, sans-serif', fontSize: '15px' },
  dropdownList: { overflowY: 'auto', flex: 1, padding: '4px 0' },
  dropdownItem: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 16px', cursor: 'pointer', transition: 'background-color 0.2s', borderLeft: '4px solid transparent', gap: '8px' },
  dropdownItemNaoLida: { backgroundColor: '#f0f9ff', borderLeftColor: '#3b82f6' },
  dropdownItemLida: { backgroundColor: '#ffffff', borderLeftColor: '#cbd5e1' },
  dropdownContent: { flex: 1, display: 'flex', flexDirection: 'column', gap: '2px' },
  dropdownText: { fontSize: '13px', color: '#1e293b', fontFamily: 'Montserrat, sans-serif' },
  dropdownTime: { fontSize: '10px', color: '#64748b', fontFamily: 'Montserrat, sans-serif' },
  dropdownClose: { background: 'none', border: 'none', color: '#94a3b8', fontSize: '18px', cursor: 'pointer', width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%' },
  dropdownEmpty: { padding: '32px 16px', textAlign: 'center', color: '#94a3b8', fontFamily: 'Montserrat, sans-serif', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' },
  closeDropdownButton: { background: 'none', border: 'none', color: '#64748b', fontSize: '24px', cursor: 'pointer', width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%' },
};

export default InterfaceAssociados;